import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { WelcomePopup } from "./WelcomePopup";
import { useScript, useTransliteration } from "../../lib/script";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const { script } = useScript();
  const root = useRef(null);
  useTransliteration(root, script === "cyrl");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div ref={root} className="flex min-h-screen flex-col">
      <SiteHeader />
      <main id="main" className="flex-1" data-testid="public-main">
        <Outlet />
      </main>
      <SiteFooter />
      <WelcomePopup />
    </div>
  );
}
